import {IBookingTypesList, IServiceTypesList, ISignLanguageList} from '../types';
import {IConfirmation} from '../main/confirmation.service';

export const SERIES_PREP_MATERIAL_DELETE_CONFIRMATION: IConfirmation = {
	title: 'Delete series-wide prep material?',
	message: 'This file was uploaded for the entire booking series and is attached to every session, not just this one. Deleting it will remove it from all sessions in the series once you save your changes, and cannot be undone.',
	confirm: 'Delete for entire series',
	cancel: 'Cancel',
	warning: true,
};

export const weekend_days = ['Saturday', 'Sunday']

export const MIN_BOOKING_CREATION_GUARANTEED = 15;
export const MAX_BOOKING_CREATION_GUARANTEED = 10080;

/** On-site captioning: short-notice booking confirmation threshold (1 week), minutes */
export const ONSITE_CAPTIONING_GUARANTEED_PERIOD_MINUTES = 7 * 24 * 60;
/** On-site captioning: minimum notice before start for cancel / time-change policy (hours) */
export const ONSITE_CAPTIONING_MINIMUM_PERIOD_TO_MODIFY_HOURS = 48;
/** On-site captioning: minimum session length (minutes) */
export const ONSITE_CAPTIONING_MINIMUM_DURATION_MINUTES = 120;
/** Topic Model Curation: short-notice booking confirmation threshold (3 days), minutes */
export const TOPIC_MODEL_CURATION_GUARANTEED_PERIOD_MINUTES = 3 * 24 * 60;
/** Topic Model Curation: fixed placeholder session duration (60 min) — there is no real
 * session, so the time picker is hidden from the user and the validator must always
 * accept exactly this value regardless of the org's configured minimum. */
export const TOPIC_MODEL_CURATION_DURATION_MINUTES = 60;
export const BOOKING_LIST: IBookingTypesList[] = [
	{
		value: 'education',
		title: 'Education class',
	},
	{
		value: 'meeting',
		title: 'Meeting'
	},
	{
		value: 'event',
		title: 'Event'
	}
];

export const SIGN_LANGUAGE_LIST: ISignLanguageList[] = [
	{
		value: 'asl',
		title: 'American Sign Language (ASL)',
	},
	{
		value: 'auslan',
		title: 'Australian Sign Language (Auslan)'
	},
	{
		value: 'bsl',
		title: 'British Sign Language (BSL)'
	},
	{
		value: 'other',
		title: 'Other'
	}
];

export const booking_defaults = {
	notes: '',
	private_link_type: 'anyone',
	allow_transcript: 0,
	caption: 0,
	audio: 0,
    audio_caption_details: 1,
	calendar_start_day: 0,
	point_of_contact: '',
	allow_confirmed_emails: 1,
	allow_canceled_emails: 1,
	allow_received_emails: 1,
	ai_live_caption_setting: {
      font: 'Arial',
      size: '44px',
      colourcombination: 'C1',
      oneword: 'Fast',
	}
}
